import { UtrvVariationWarning } from '@g17eco/types/question';
import React, { createContext, useContext } from 'react';
import { VariationWarningMessage } from './VariationWarningMessage';

interface VariationContextProps {
  getVariationWarningMessage: (valueListCode?: string) => React.ReactNode;
  variationWarnings: UtrvVariationWarning[];
  utrvId?: string;
}

export const VariationContext = createContext<VariationContextProps>({
  getVariationWarningMessage: () => null,
  variationWarnings: [],
  utrvId: undefined,
});

export const useVariationContext = () => {
  return useContext(VariationContext);
};

interface Props {
  children: JSX.Element;
  variationWarnings: UtrvVariationWarning[];
  utrvId?: string;
}

export const VariationContextProvider = ({ children, variationWarnings, utrvId }: Props) => {
  const getVariationWarningMessage = (valueListCode?: string) => {
    const variationWarning = valueListCode
      ? variationWarnings.find((warning) => warning.valueListCode === valueListCode)
      : variationWarnings[0];
    if (!variationWarning) {
      return null;
    }
    return <VariationWarningMessage variationWarning={variationWarning} />;
  };

  return (
    <VariationContext.Provider value={{ getVariationWarningMessage, utrvId, variationWarnings }}>
      {children}
    </VariationContext.Provider>
  );
};
